module.exports = __webpack_public_path__ + "img/20190601135142408.9f4c0a86.png";